<template>
	<section class="goal-sub-header-layout">
		<main class="goal-sub-header-layout__main">
			<div class="goal-sub-header-layout__stack team-name-stack">
				<slot name="team-name"></slot>
			</div>
			<div class="goal-sub-header-layout__stack due-date-stack">
				<slot name="due-date"></slot>
			</div>
			<div class="goal-sub-header-layout__stack last-updated-stack">
				<slot name="last-updated"></slot>
			</div>
			<div class="goal-sub-header-layout__stack confidence-stack">
				<slot name="confidence-level"></slot>
			</div>
			<div class="goal-sub-header-layout__stack progress-stack">
				<slot name="progress"></slot>
			</div>
		</main>
	</section>
</template>

<script>
export default {
	name: "GoalSubHeaderLayout",
};
</script>

<style lang="scss" scoped>
$goalSubHeaderLayoutBorderColor: $color1-200;

.goal-sub-header-layout {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	gap: 0.6rem;

	padding: 1rem;

	@include for-size('md') {
		border-bottom: 0.0625rem solid $goalSubHeaderLayoutBorderColor;
		padding: 0 1rem 2rem 1rem;
	}

}

.goal-sub-header-layout__main {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	gap: 2rem;

	:last-child {
		flex: 1;
	}
}

.goal-sub-header-layout__stack {
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
	gap: 0.4rem;
}

.goal-sub-header-layout__stack.team-name-stack,
.goal-sub-header-layout__stack.last-updated-stack {
	display: none;

	@include for-size('md') {
		display: flex;
	}
}
</style>
